import * as React from "react";
import { ChevronDownIcon } from "lucide-react";

import { Button } from "../ui/button";
import { Calendar } from "../ui/calendar";
import { Label } from "../ui/label";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";

type Props = {
  date: Date | undefined;
  setDate: React.Dispatch<React.SetStateAction<Date | undefined>>;
  label?: string;
  startMonth?: Date;
  endMonth?: Date;
};

const InputDate = ({ date, setDate, label, startMonth, endMonth }: Props) => {
  const [open, setOpen] = React.useState(false);

  return (
    <div className="flex flex-col">
      {label && (
        <Label htmlFor="date" className="px-1 text-brand-text">
          {label}
        </Label>
      )}
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            id="date"
            className="justify-between font-normal py-[21px] text-brand-text border !border-brand-text"
          >
            {date ? date.toLocaleDateString() : "dd/mm/aaaa"}
            <ChevronDownIcon />
          </Button>
        </PopoverTrigger>
        <PopoverContent
          className="z-[1001] w-auto overflow-hidden p-0 absolute bg-brand-sidebar border-none rounded-2xl"
          align="start"
        >
          <Calendar
            mode="single"
            selected={date}
            captionLayout="dropdown"
            onSelect={(date) => {
              setDate(date);
              setOpen(false);
            }}
            startMonth={startMonth}
            endMonth={endMonth}
            classNames={{
              months: "text-white rounded-lg p-2",
              caption_label: "hidden",
              chevron: "h-10 w-8 mb-2",
              nav: "flex justify-between",
              nav_button: "text-white hover:bg-slateblue rounded-md",
              table: "w-full",
              head_row: "flex",
              head_cell: "w-9 text-xs font-medium text-slate-300 text-center",
              row: "flex w-full mt-2",
              cell: "h-9 w-9 text-center text-sm relative",
              day: "h-9 w-9 rounded-md hover:bg-slateblue-light",
              day_selected: "bg-brand-primary text-white hover:bg-brand-primary/90",
              day_today: "border border-brand-primary",
              day_outside: "text-slate-500 opacity-50",
              dropdown: "w-28 p-1 px-2 border-b-2 bg-brand-sidebar",
              dropdowns: "flex p-0 w-full justify-evenly",
              dropdown_root: "border-none",
            }}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
};
export default InputDate;
